"use client";

import { useProductsInfo } from "@/lib/products-info";
import { buildGbTiers } from "@/lib/pricing-utils";
import PricingTierGrid from "@/components/sections/products/shared/pricing-tier-grid";
import { FALLBACK_MOBILE_GB_TIERS, PLAN_FEATURES, CARD_PLAN_NAMES, CARD_HIGHLIGHTS } from "./data";

export default function MobileTierGrid() {
  const info = useProductsInfo();
  const tiers = buildGbTiers(info?.["Monthly Per GB Mobile"] ?? [], FALLBACK_MOBILE_GB_TIERS);

  return (
    <PricingTierGrid
      tiers={tiers}
      planNames={CARD_PLAN_NAMES}
      cardHighlights={CARD_HIGHLIGHTS}
      sharedFeatures={PLAN_FEATURES}
      enterpriseTitle="Need more than 10 TB?"
      enterpriseDescription="Custom rotation rules, priority support, higher volume limits, and custom pricing that may start at $0.50/GB above 10 TB, depending on volume and contract terms."
    />
  );
}
